export default __webpack_public_path__ + "static/media/AwaitingDocs.e5e5a643.svg";